export enum NavState {
	PROJECTS = 'projects',
	SETTINGS = 'settings',
	EDITOR = 'editor',
	AD_EDITOR = 'ad-editor',
	AD_STUDIO = 'ad-studio',
	HOME = 'home',
}
